import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";

function TagInRow(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <span className="dib padd5 fs13 b1 bg-const3 mright5 mbottom5">
      {props.item} <span className="mdi mdi-close pointer" onClick={()=>{ props.deleteMe(); }}></span>
    </span>
  )
};

TagInRow.defaultProps = {};

TagInRow.propTypes = {}

export default observer(TagInRow);
